var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSum123Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 23,
    viewBox: "0 0 87 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7789_97186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.444702 23V0H31.356V5.36668L28.4281 5.36665L28.6586 3.29259H25.3615L25.1216 5.36665L24.3004 13.7979L31.356 13.7979V23H0.444702Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7789_97186)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23374 23L9.49275 20.5357L15.6197 17.25L15.9651 13.9643L6.17742 4.92857L6.52276 1.64286H11.4785L11.6511 0H19.0847H26.5182L26.3455 1.64286H31.3012L30.9559 4.92857L19.2689 13.9643L18.9235 17.25L24.3598 20.5357L24.1008 23H16.6673H9.23374ZM12.1317 3.28571H8.82794L8.74161 4.10714L11.7864 6.57143L12.1317 3.28571ZM25.3469 3.28571H28.6507L28.5644 4.10714L25.0016 6.57143L25.3469 3.28571Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3075 1.76416L19.589 1.76416L18.5892 11.3123L16.9837 11.3123L17.7442 4.05967H17.7301L16.4767 5.24263H16.4626L16.6457 3.49635L18.3075 1.76416Z",
    fill: "#161C31"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7789_97186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 31,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2893 0V5.36675L35.9662 5.36681L36.1948 3.30382H39.4984L39.2734 5.36683L38.4178 13.8L28.2893 13.8V23H58.9556V13.7979L51.6503 13.7979L52.4716 5.36665L52.7114 3.29259H56.0086L55.7781 5.36665L58.9556 5.36668V0H28.2893Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7789_97186)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5978 23L36.8568 20.5357L42.9837 17.25L43.3291 13.9643L33.5414 4.92857L33.8868 1.64286H38.8425L39.0151 0H46.4487H53.8822L53.7096 1.64286H58.6652L58.3199 4.92857L46.6329 13.9643L46.2875 17.25L51.7238 20.5357L51.4648 23H44.0313H36.5978ZM39.4958 3.28571H36.192L36.1056 4.10714L39.1504 6.57143L39.4958 3.28571ZM52.7109 3.28571H56.0147L55.9284 4.10714L52.3656 6.57143L52.7109 3.28571Z",
    fill: "#D9D7CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0698 11.3122L43.2529 9.55186C43.3656 8.49564 43.7458 8.01682 44.7034 7.05919L45.6752 6.10155C46.2244 5.55232 46.3793 5.2425 46.4497 4.45386L46.5342 3.66522C46.5905 3.1019 46.2948 2.94699 45.9709 2.94699C45.6329 2.94699 45.3512 3.1019 45.2949 3.65114L45.1682 4.89043L43.7036 4.89043L43.8444 3.55256C43.9711 2.31326 44.7175 1.65137 46.0695 1.65137C47.6045 1.65137 48.2523 2.39776 48.0974 3.80605L47.9988 4.73552C47.8862 5.7354 47.6468 6.15789 46.7314 7.07327L45.6188 8.15765C45.1682 8.60831 44.8443 8.93221 44.7739 9.60819L44.7316 10.0025L47.3792 10.0025L47.2384 11.3122L43.0698 11.3122Z",
    fill: "#161C31"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7789_97186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 0,
    width: 32,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8889 5.36675V0H86.5552V23H55.8889V13.8L66.0174 13.8L66.873 5.36683L67.098 3.30382H63.7945L63.5658 5.36681L55.8889 5.36675Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7789_97186)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1974 23L64.4564 20.5357L70.5834 17.25L70.9287 13.9643L61.141 4.92857L61.4864 1.64286H66.4421L66.6148 0H74.0483H81.4818L81.3092 1.64286H86.2649L85.9195 4.92857L74.2325 13.9643L73.8872 17.25L79.3235 20.5357L79.0644 23H71.6309H64.1974ZM67.0954 3.28571H63.7916L63.7052 4.10714L66.75 6.57143L67.0954 3.28571ZM80.3105 3.28571H83.6143L83.528 4.10714L79.9652 6.57143L80.3105 3.28571Z",
    fill: "#E77238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6511 1.65137C75.2283 1.65137 75.848 2.62309 75.6931 3.97504L75.6086 4.77776C75.51 5.60865 75.0875 6.04522 74.3693 6.25647C75.2002 6.48179 75.4537 7.15777 75.3551 8.04499L75.2143 9.38286C75.1016 10.5658 74.3834 11.4249 72.8483 11.4249C71.2006 11.4249 70.5669 10.4109 70.7218 9.00262L70.8486 7.7915L72.3132 7.7915L72.1724 9.14345C72.116 9.70677 72.2991 10.087 72.8765 10.087C73.3694 10.087 73.5666 9.81943 73.6229 9.25612L73.7919 7.65067C73.8482 7.14369 73.6652 6.87611 73.1018 6.87611L72.4118 6.87611L72.5385 5.6509L73.1018 5.6509C73.6652 5.6509 74.0313 5.38333 74.0876 4.80593L74.1862 3.84829C74.2425 3.29906 74.0595 2.98924 73.5525 2.98924C73.0455 2.98924 72.8202 3.25681 72.7638 3.82013L72.6512 4.89043L71.1866 4.89043L71.2992 3.83421C71.426 2.52451 72.0879 1.65137 73.6511 1.65137Z",
    fill: "#161C31"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2781 13.4963L27.4961 11.3645H30.2092L30.5242 8.43335H32.8013L32.4863 11.3645H35.1753L34.9572 13.4963H32.2683L31.9534 16.4274H29.6763L29.9912 13.4963H27.2781Z",
    fill: "#798BB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8781 13.4963L55.0961 11.3645H57.8092L58.1241 8.43335H60.4012L60.0863 11.3645H62.7752L62.5572 13.4963H59.8683L59.5534 16.4274H57.2763L57.5912 13.4963H54.8781Z",
    fill: "#798BB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum123Updated);
export default __webpack_public_path__ + "static/media/sum-1-2-3-updated.541390995b6cdfd73ee5b573de002e61.svg";
export { ForwardRef as ReactComponent };